import httpClient from "@/http-client";

export const profitAndLoss = (options = {}) => {
    return httpClient
        .get("/api/reports/accountings/profit-and-losses", options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};
export const summaryOfActiveAccount = (options = {}) => {
    return httpClient
        .get("/api/reports/accountings/summary-of-active-accounts", options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};
export const trialBalance = (options = {}) => {
    return httpClient
        .get("/api/reports/accountings/trial-balances", options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};
export const balanceSheet = (options = {}) => {
    return httpClient
        .get("/api/reports/accountings/balance-sheets", options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};
export const generalJournalRecord = (options = {}) => {
    return httpClient
        .get("/api/reports/accountings/general-journal-records", options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};
export const generalLedger = (options = {}) => {
    return httpClient
        .get("/api/reports/accountings/general-ledgers", options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const generalLedgerExportExcel = attributes => {
    return httpClient
        .post("/api/reports/accountings/general-ledgers/excel", attributes, {
            responseType: "arraybuffer"
        })
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data));
};
export const generalJournalRecordExportExcel = attributes => {
    return httpClient
        .post(
            "/api/reports/accountings/general-journal-records/excel",
            attributes,
            {
                responseType: "arraybuffer"
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data));
};

// v3 — General Ledger (partition-child UNION, running balance via window)
export const generalLedgerV3 = (options = {}) => {
    return httpClient
        .get("/api/reports/accountings/general-ledgers-v3", options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};
export const generalLedgerV3ExportExcel = attributes => {
    return httpClient
        .post(
            "/api/reports/accountings/general-ledgers-v3/excel",
            attributes,
            {
                responseType: "arraybuffer"
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data));
};

// v3 — General Journal Record (partition-child aware, paginated by line)
export const generalJournalRecordV3 = (options = {}) => {
    return httpClient
        .get("/api/reports/accountings/general-journal-records-v3", options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};
export const generalJournalRecordV3ExportExcel = attributes => {
    return httpClient
        .post(
            "/api/reports/accountings/general-journal-records-v3/excel",
            attributes,
            {
                responseType: "arraybuffer"
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data));
};
export const generalJournalRecordV3ExportPdf = attributes => {
    // v2 PDF generator saves to storage and returns { url } — load in iframe.
    return httpClient
        .post(
            "/api/reports/accountings/general-journal-records-v3/pdf",
            attributes
        )
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};
export const trialBalanceExportExcel = attributes => {
    return httpClient
        .post("/api/reports/accountings/trial-balances/excel", attributes, {
            responseType: "arraybuffer"
        })
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data));
};
export const balanceSheetExportExcel = attributes => {
    return httpClient
        .post("/api/reports/accountings/balance-sheets/excel", attributes, {
            responseType: "arraybuffer"
        })
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data));
};
export const profitAndLossExportExcel = attributes => {
    return httpClient
        .post("/api/reports/accountings/profit-and-losses/excel", attributes, {
            responseType: "arraybuffer"
        })
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data));
};
export const summaryOfActiveAccountExportExcel = attributes => {
    return httpClient
        .post(
            "/api/reports/accountings/summary-of-active-accounts/excel",
            attributes,
            {
                responseType: "arraybuffer"
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data));
};
export const summaryOfActiveAccountRawDataCSV = attributes => {
    return httpClient
        .post(
            "/api/reports/accountings/summary-of-active-accounts/excel",
            attributes
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data));
};
export default {
    profitAndLoss,
    summaryOfActiveAccount,
    trialBalance,
    balanceSheet,
    generalJournalRecord,
    generalLedger,
    generalLedgerExportExcel,
    generalJournalRecordExportExcel,
    generalJournalRecordV3,
    generalJournalRecordV3ExportExcel,
    generalJournalRecordV3ExportPdf,
    generalLedgerV3,
    generalLedgerV3ExportExcel,
    trialBalanceExportExcel,
    balanceSheetExportExcel,
    profitAndLossExportExcel,
    summaryOfActiveAccountRawDataCSV,
    summaryOfActiveAccountExportExcel
};
